import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Register from "./pages/Register";
import Upload from "./pages/Upload";
import Admin from "./pages/Admin";

import Settings from "./pages/Settings";
function App() {
  return (
    <div className="App font-sans antialiased text-foreground bg-background">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/register" element={<Register />} />
          <Route path="/upload" element={<Upload />} />
          <Route path="/success" element={<Upload />} /> {/* Alias for success */}
          <Route path="/admin/settings" element={<Settings />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
